import React from 'react';

const Shared = (props) => {
	return (
		<svg
			version="1.1"
			baseProfile="tiny"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			width={props.width}
			height={props.height}
			xmlSpace="preserve"
			className="pics align-middle mr-1"
			viewBox="0 0 100 100"
		>
			<path fill="#31A348" d="M98.9,57.7l-5.1-5.1c-0.7-0.7-1.6-1.1-2.6-1.1c-1,0-1.9,0.4-2.5,1.1L64.1,77.3l-11-11.1
			                    c-0.7-0.7-1.6-1.1-2.6-1.1c-1,0-1.9,0.4-2.5,1.1l-5.1,5.1c-0.7,0.7-1.1,1.6-1.1,2.6c0,1,0.4,1.9,1.1,2.5l18.7,18.7
			                    c0.7,0.7,1.6,1.1,2.5,1.1c1,0,1.9-0.4,2.6-1.1l5.1-5.1l27.2-27.2c0.7-0.7,1.1-1.6,1.1-2.5C100,59.3,99.6,58.4,98.9,57.7z"/>
			<path fill="#606060" d="M37.6,45.2c6.3,0,11.6-2.2,16-6.6c4.4-4.4,6.6-9.7,6.6-16c0-6.3-2.2-11.6-6.6-16C49.2,2.2,43.8,0,37.6,0
			                    c-6.2,0-11.6,2.2-16,6.6c-4.4,4.4-6.6,9.8-6.6,16c0,6.2,2.2,11.6,6.6,16C26.1,43,31.4,45.2,37.6,45.2z"/>
			<path fill="#606060" d="M36.2,73.9c0-0.9,0.1-1.9,0.4-2.7c0.1-0.4,0.2-0.7,0.4-1c0.5-1,1.1-2,1.9-2.8l5.1-5.1
			                    c1.8-1.8,4.1-2.7,6.5-2.7c2.5,0,4.8,0.9,6.6,2.7l7.1,7.1l9.7-9.7l0,0c0,0,0,0,0,0l0,0c-0.3-1.1-0.5-2.2-0.9-3.2
			                    c-0.9-3-2.1-5.6-3.4-7.7c-1.4-2.2-3.2-3.9-5.5-5.3c-2.3-1.4-4.9-2-7.9-2c-5.1,5-11.3,7.5-18.4,7.5c-7.2,0-13.3-2.5-18.4-7.5
			                    c-3,0-5.6,0.7-7.9,2c-2.3,1.4-4.1,3.1-5.5,5.3c-1.4,2.1-2.5,4.7-3.4,7.7c-0.9,3-1.5,6-1.9,8.9c-0.3,3-0.5,6.1-0.5,9.4
			                    c0,4.3,1.2,7.5,3.7,10.6c2.5,3.1,5.4,4.2,8.9,4.2h36.2L38.9,80C37.1,78.3,36.2,76.4,36.2,73.9z"/>
		</svg>
	);
};

export default Shared;
